import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router";

import makeStyles from "@material-ui/core/styles/makeStyles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { Box, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Add } from "@material-ui/icons";
import Create from "@material-ui/icons/Create";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import GridContainer from "@jumbo/components/GridContainer";

import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { fetchError } from "redux/actions";
import TestsRequests from "services/tests";

import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ImagePicker from "../compnents/ImagePicker";
import FileUploader from "@jumbo/Dashboards/Media/FileUploader";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
  },
  cardRoot: {
    paddingTop: "24px",
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
    paddingInline: "25px",
  },
  formContainer: {
    width: "100%",
  },
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  customInput: {
    width: "80%",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  inputContainer: {
    paddingInline: "40px !important",
    "& p": {
      fontWeight: "bold",
      marginBottom: "16px",
    },
  },
  buttonContainer: {
    paddingInline: "40px !important",
    justifyContent: "flex-end",
  },
  inputTitle: {
    marginBottom: "20px",
  },
  select: {
    height: "56px",
    "& .MuiOutlinedInput-input": {
      height: "25px",
    },
  },
  previewContainer: {
    width: "100%",
    paddingLeft: "50%",
    display: "flex",
    justifyContent: "center",
    "& img": {
      width: "190px",
    },
  },
  removeButton: {
    cursor: "pointer",
  },
}));

const MarathondEventFields = () => {
  const now = new Date();
  now.setHours(18, 0, 0, 0);

  const [testTitle, setTestTitle] = useState("");
  const [testDesc, setTestDesc] = useState("");
  const [fromDate, setFromDate] = useState({
    date: now,
    gregorian: new DateObject({ date: now, format: "HH:mm:ss   YYYY/MM/DD" })
      .convert(gregorian, gregorian_en)
      .format(),
  });
  const [toDate, setToDate] = useState({
    date: now,
    gregorian: new DateObject({ date: now, format: "HH:mm:ss   YYYY/MM/DD" })
      .convert(gregorian, gregorian_en)
      .format(),
  });
  const [testTime, setTestTime] = useState(10);
  const [maxQuestions, setMaxQuestions] = useState(10);
  const [active, setActive] = useState(false);
  const [archived, setArchived] = useState(false);
  const [cover, setCover] = useState("");
  const [openFileUploader, setOpenFileUploader] = useState(false);
  const [
    maxQuestionsFromOneCategory,
    setMaxQuestionsFromOneCategory,
  ] = useState(3);

  const { marathonEventById } = useSelector(({ tests }) => tests);

  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    if (marathonEventById) {
      if (marathonEventById._id === id) {
        setTestTitle(marathonEventById.title);
        setTestDesc(marathonEventById.description);
        setFromDate({
          date: marathonEventById.startDate,
          gregorian: new DateObject({
            date: marathonEventById.startDate,
            format: "HH:mm:ss   YYYY/MM/DD",
          })
            .convert(gregorian, gregorian_en)
            .format(),
        });
        setToDate({
          date: marathonEventById.endDate,
          gregorian: new DateObject({
            date: marathonEventById.endDate,
            format: "HH:mm:ss   YYYY/MM/DD",
          })
            .convert(gregorian, gregorian_en)
            .format(),
        });
        setTestTime(+marathonEventById.durationInMinutes);
        setActive(marathonEventById.active);
        setCover(marathonEventById.cover);
        setArchived(marathonEventById.archived);
        setMaxQuestions(marathonEventById?.maxQuestions || 0);
        setMaxQuestionsFromOneCategory(marathonEventById?.maxQuestionsFromOneCategory || 0);
      }
    }
  }, [marathonEventById]);

  useEffect(() => {
    if (id) {
      dispatch(TestsRequests.getMarathonEventById(id));
    }
  }, [id]);

  const convertFromDate = (date, format = fromDate.format) => {
    let object = { date, format };
    setFromDate({
      gregorian: new DateObject(object)
        .convert(gregorian, gregorian_en)
        .format(),
      ...object,
    });
  };
  const convertToDate = (date, format = toDate.format) => {
    let object = { date, format };
    setToDate({
      gregorian: new DateObject(object)
        .convert(gregorian, gregorian_en)
        .format(),
      ...object,
    });
  };

  const convertToStandardFormat = (dateString) => {
    const [time, date] = dateString.split("   ");
    const [hours, minutes, seconds] = time.split(":");
    const [year, month, day] = date.split("/");
    const standardFormat = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    const dateObject = new Date(standardFormat);
    const isoString = dateObject.toISOString();
    return isoString;
  };

  const handleCreateTest = () => {
    if (testTitle && fromDate.date && toDate.date && testTime) {
      const eventData = {
        title: testTitle,
        description: testDesc,
        startDate: convertToStandardFormat(fromDate.gregorian),
        endDate: convertToStandardFormat(toDate.gregorian),
        durationInMinutes: testTime,
        archived: archived,
        active: active,
        cover: cover,
        maxQuestions: maxQuestions,
        maxQuestionsFromOneCategory: maxQuestionsFromOneCategory,
      };
      dispatch(TestsRequests.createMarathonEvent(eventData, history));
    } else {
      dispatch(fetchError("موارد لازم را به درستی وارد نمایید"));
    }
  };

  const handleUpdateTest = () => {
    if (testTitle && fromDate.date && toDate.date && testTime) {
      const eventData = {
        title: testTitle,
        description: testDesc,
        startDate: convertToStandardFormat(fromDate.gregorian),
        endDate: convertToStandardFormat(toDate.gregorian),
        durationInMinutes: testTime,
        archived: archived,
        active: active,
        cover: cover,
        maxQuestions: maxQuestions,
        maxQuestionsFromOneCategory: maxQuestionsFromOneCategory,
      };
      dispatch(TestsRequests.updateMarathonEventById(id, eventData, history));
    } else {
      dispatch(fetchError("موارد لازم را به درستی وارد نمایید"));
    }
  };

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <form className={classes.formContainer} noValidate autoComplete="off">
          <GridContainer className={classes.girdContainer}>
            {id && (
              <Typography variant="h4" gutterBottom align="center">
                 ویرایش آزمون : {testTitle}
              </Typography>
            ) }
            <Grid item xs={12}>
              <TextField
                id="quizNameField"
                label="نام آزمون"
                variant="outlined"
                className={classes.customInput}
                value={testTitle}
                onChange={(e) => setTestTitle(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="nationalCodeInput"
                multiline
                minRows={4}
                label="توضیحات"
                variant="outlined"
                className={classes.customInput}
                value={testDesc}
                onChange={(e) => setTestDesc(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Box display={"flex"} alignItems="center">
                <CalendarTodayIcon fontSize="small" />
                <Box marginLeft={2}>
                  <Typography>تاریخ شروع</Typography>
                </Box>
              </Box>

              <DatePicker
                containerClassName="custom-container"
                calendar={persian}
                locale={persian_fa}
                calendarPosition="bottom-right"
                value={fromDate.date}
                onChange={convertFromDate}
                format="HH:mm:ss   YYYY/MM/DD"
                plugins={[<TimePicker position="bottom" />]}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box display={"flex"} alignItems="center">
                <CalendarTodayIcon fontSize="small" />
                <Box marginLeft={2}>
                  <Typography>تاریخ پایان</Typography>
                </Box>
              </Box>
              <DatePicker
                containerClassName="custom-container"
                calendar={persian}
                locale={persian_fa}
                calendarPosition="bottom-right"
                value={toDate.date}
                type="Input"
                onChange={convertToDate}
                format="HH:mm:ss   YYYY/MM/DD"
                plugins={[<TimePicker position="bottom" />]}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography className={classes.inputTitle}>
                {`زمان کوییز(دقیقه)`}
              </Typography>
              <TextField
                id="quizTimeField"
                label="زمان کوییز"
                variant="outlined"
                type="number"
                className={classes.customInput}
                value={testTime}
                onChange={(e) => setTestTime(e.target.value)}
                onWheel={(e) => e.target.blur()}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography className={classes.inputTitle}>
                {"حداکثر سوال قابل پاسخ"}
              </Typography>
              <TextField
                id="maxQuestionsField"
                label="حداکثر سوال قابل پاسخ"
                variant="outlined"
                type="number"
                className={classes.customInput}
                value={maxQuestions}
                onChange={(e) => setMaxQuestions(e.target.value)}
                onWheel={(e) => e.target.blur()}
              />
            </Grid>
               <Grid item xs={12} md={6}>
              <Typography className={classes.inputTitle}>
                {"حداکثر سوال قابل پاسخ برای هر دسته بندی"}
              </Typography>
              <TextField
                id="maxQuestionsFromOneCategoryField"
                label="حداکثر سوال قابل پاسخ برای هر دسته بندی"
                variant="outlined"
                type="number"
                className={classes.customInput}
                value={maxQuestionsFromOneCategory}
                onChange={(e) => setMaxQuestionsFromOneCategory(e.target.value)}
                onWheel={(e) => e.target.blur()}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography className={classes.answerSelectText}>
                انتخاب تصویر آزمون
              </Typography>
              <ImagePicker
                cover={cover}
                handlePick={() => setOpenFileUploader(true)}
                handleRevome={() => setCover("")}
                previewStyles={{ marginInline: "auto", marginBlock: "20px" }}
                placeHolderStyles={{
                  marginInline: "auto",
                  marginBlock: "20px",
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography className={classes.inputTitle}>فعال</Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={active}
                    onChange={() => setActive((prev) => !prev)}
                    name="active"
                  />
                }
                label="فعال"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography className={classes.inputTitle}>آرشیو</Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={archived}
                    onChange={() => setArchived((prev) => !prev)}
                    name="archived"
                  />
                }
                label="آرشیو"
              />
            </Grid>
            <Grid item xs={12} container className={classes.buttonContainer}>
              {id ? (
                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  startIcon={<Create />}
                  onClick={handleUpdateTest}
                >
                  ویرایش آزمون
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  startIcon={<Add />}
                  onClick={handleCreateTest}
                >
                  ساخت آزمون
                </Button>
              )}
            </Grid>
          </GridContainer>
        </form>
      </CmtCardContent>
      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelect={(selected) => setCover(selected)}
        selectedItem={cover}
        imageSelector={true}
      />
    </CmtCard>
  );
};

export default MarathondEventFields;
